/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VerifyEmailRouteImport } from './routes/verify-email'
import { Route as SignUpRouteImport } from './routes/sign-up'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as AppRouteRouteImport } from './routes/app/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppIndexRouteImport } from './routes/app/index'
import { Route as AppSettingsRouteImport } from './routes/app/settings'
import { Route as AppPostsRouteImport } from './routes/app/posts'
import { Route as AppMoreRouteImport } from './routes/app/more'
import { Route as AppIntegrationsRouteImport } from './routes/app/integrations'
import { Route as AppInboxRouteImport } from './routes/app/inbox'
import { Route as AppGenerateRouteImport } from './routes/app/generate'
import { Route as AppCareersRouteImport } from './routes/app/careers'
import { Route as AppCalendarRouteImport } from './routes/app/calendar'
import { Route as AppBulkRouteImport } from './routes/app/bulk'
import { Route as AppBillingRouteImport } from './routes/app/billing'
import { Route as AppAuditRouteImport } from './routes/app/audit'
import { Route as AppAnalyticsRouteImport } from './routes/app/analytics'
import { Route as AppBrandsIndexRouteImport } from './routes/app/brands/index'
import { Route as AppBrandsNewRouteImport } from './routes/app/brands/new'
import { Route as AppBrandsBrandIdRouteImport } from './routes/app/brands/$brandId'
import { Route as AppBrandsBrandIdIntegrationsRouteImport } from './routes/app/brands/$brandId.integrations'

const VerifyEmailRoute = VerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => rootRouteImport,
} as any)
const SignUpRoute = SignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRouteRoute = AppRouteRouteImport.update({
  id: '/app',
  path: '/app',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppPostsRoute = AppPostsRouteImport.update({
  id: '/posts',
  path: '/posts',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppMoreRoute = AppMoreRouteImport.update({
  id: '/more',
  path: '/more',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppIntegrationsRoute = AppIntegrationsRouteImport.update({
  id: '/integrations',
  path: '/integrations',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppInboxRoute = AppInboxRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppGenerateRoute = AppGenerateRouteImport.update({
  id: '/generate',
  path: '/generate',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppCareersRoute = AppCareersRouteImport.update({
  id: '/careers',
  path: '/careers',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppCalendarRoute = AppCalendarRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppBulkRoute = AppBulkRouteImport.update({
  id: '/bulk',
  path: '/bulk',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppBillingRoute = AppBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppAuditRoute = AppAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppAnalyticsRoute = AppAnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppBrandsIndexRoute = AppBrandsIndexRouteImport.update({
  id: '/brands/',
  path: '/brands/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppBrandsNewRoute = AppBrandsNewRouteImport.update({
  id: '/brands/new',
  path: '/brands/new',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppBrandsBrandIdRoute = AppBrandsBrandIdRouteImport.update({
  id: '/brands/$brandId',
  path: '/brands/$brandId',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppBrandsBrandIdIntegrationsRoute =
  AppBrandsBrandIdIntegrationsRouteImport.update({
    id: '/integrations',
    path: '/integrations',
    getParentRoute: () => AppBrandsBrandIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/app': typeof AppRouteRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/onboarding': typeof OnboardingRoute
  '/reset-password': typeof ResetPasswordRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/verify-email': typeof VerifyEmailRoute
  '/app/analytics': typeof AppAnalyticsRoute
  '/app/audit': typeof AppAuditRoute
  '/app/billing': typeof AppBillingRoute
  '/app/bulk': typeof AppBulkRoute
  '/app/calendar': typeof AppCalendarRoute
  '/app/careers': typeof AppCareersRoute
  '/app/generate': typeof AppGenerateRoute
  '/app/inbox': typeof AppInboxRoute
  '/app/integrations': typeof AppIntegrationsRoute
  '/app/more': typeof AppMoreRoute
  '/app/posts': typeof AppPostsRoute
  '/app/settings': typeof AppSettingsRoute
  '/app/': typeof AppIndexRoute
  '/app/brands/$brandId': typeof AppBrandsBrandIdRouteWithChildren
  '/app/brands/new': typeof AppBrandsNewRoute
  '/app/brands/': typeof AppBrandsIndexRoute
  '/app/brands/$brandId/integrations': typeof AppBrandsBrandIdIntegrationsRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/onboarding': typeof OnboardingRoute
  '/reset-password': typeof ResetPasswordRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/verify-email': typeof VerifyEmailRoute
  '/app/analytics': typeof AppAnalyticsRoute
  '/app/audit': typeof AppAuditRoute
  '/app/billing': typeof AppBillingRoute
  '/app/bulk': typeof AppBulkRoute
  '/app/calendar': typeof AppCalendarRoute
  '/app/careers': typeof AppCareersRoute
  '/app/generate': typeof AppGenerateRoute
  '/app/inbox': typeof AppInboxRoute
  '/app/integrations': typeof AppIntegrationsRoute
  '/app/more': typeof AppMoreRoute
  '/app/posts': typeof AppPostsRoute
  '/app/settings': typeof AppSettingsRoute
  '/app': typeof AppIndexRoute
  '/app/brands/$brandId': typeof AppBrandsBrandIdRouteWithChildren
  '/app/brands/new': typeof AppBrandsNewRoute
  '/app/brands': typeof AppBrandsIndexRoute
  '/app/brands/$brandId/integrations': typeof AppBrandsBrandIdIntegrationsRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/app': typeof AppRouteRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/onboarding': typeof OnboardingRoute
  '/reset-password': typeof ResetPasswordRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/verify-email': typeof VerifyEmailRoute
  '/app/analytics': typeof AppAnalyticsRoute
  '/app/audit': typeof AppAuditRoute
  '/app/billing': typeof AppBillingRoute
  '/app/bulk': typeof AppBulkRoute
  '/app/calendar': typeof AppCalendarRoute
  '/app/careers': typeof AppCareersRoute
  '/app/generate': typeof AppGenerateRoute
  '/app/inbox': typeof AppInboxRoute
  '/app/integrations': typeof AppIntegrationsRoute
  '/app/more': typeof AppMoreRoute
  '/app/posts': typeof AppPostsRoute
  '/app/settings': typeof AppSettingsRoute
  '/app/': typeof AppIndexRoute
  '/app/brands/$brandId': typeof AppBrandsBrandIdRouteWithChildren
  '/app/brands/new': typeof AppBrandsNewRoute
  '/app/brands/': typeof AppBrandsIndexRoute
  '/app/brands/$brandId/integrations': typeof AppBrandsBrandIdIntegrationsRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/app'
    | '/forgot-password'
    | '/onboarding'
    | '/reset-password'
    | '/sign-in'
    | '/sign-up'
    | '/verify-email'
    | '/app/analytics'
    | '/app/audit'
    | '/app/billing'
    | '/app/bulk'
    | '/app/calendar'
    | '/app/careers'
    | '/app/generate'
    | '/app/inbox'
    | '/app/integrations'
    | '/app/more'
    | '/app/posts'
    | '/app/settings'
    | '/app/'
    | '/app/brands/$brandId'
    | '/app/brands/new'
    | '/app/brands/'
    | '/app/brands/$brandId/integrations'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/forgot-password'
    | '/onboarding'
    | '/reset-password'
    | '/sign-in'
    | '/sign-up'
    | '/verify-email'
    | '/app/analytics'
    | '/app/audit'
    | '/app/billing'
    | '/app/bulk'
    | '/app/calendar'
    | '/app/careers'
    | '/app/generate'
    | '/app/inbox'
    | '/app/integrations'
    | '/app/more'
    | '/app/posts'
    | '/app/settings'
    | '/app'
    | '/app/brands/$brandId'
    | '/app/brands/new'
    | '/app/brands'
    | '/app/brands/$brandId/integrations'
  id:
    | '__root__'
    | '/'
    | '/app'
    | '/forgot-password'
    | '/onboarding'
    | '/reset-password'
    | '/sign-in'
    | '/sign-up'
    | '/verify-email'
    | '/app/analytics'
    | '/app/audit'
    | '/app/billing'
    | '/app/bulk'
    | '/app/calendar'
    | '/app/careers'
    | '/app/generate'
    | '/app/inbox'
    | '/app/integrations'
    | '/app/more'
    | '/app/posts'
    | '/app/settings'
    | '/app/'
    | '/app/brands/$brandId'
    | '/app/brands/new'
    | '/app/brands/'
    | '/app/brands/$brandId/integrations'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRouteRoute: typeof AppRouteRouteWithChildren
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  OnboardingRoute: typeof OnboardingRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SignInRoute: typeof SignInRoute
  SignUpRoute: typeof SignUpRoute
  VerifyEmailRoute: typeof VerifyEmailRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/verify-email': {
      id: '/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof VerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-up': {
      id: '/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof SignUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app': {
      id: '/app'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof AppRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/': {
      id: '/app/'
      path: '/'
      fullPath: '/app/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/settings': {
      id: '/app/settings'
      path: '/settings'
      fullPath: '/app/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/posts': {
      id: '/app/posts'
      path: '/posts'
      fullPath: '/app/posts'
      preLoaderRoute: typeof AppPostsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/more': {
      id: '/app/more'
      path: '/more'
      fullPath: '/app/more'
      preLoaderRoute: typeof AppMoreRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/integrations': {
      id: '/app/integrations'
      path: '/integrations'
      fullPath: '/app/integrations'
      preLoaderRoute: typeof AppIntegrationsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/inbox': {
      id: '/app/inbox'
      path: '/inbox'
      fullPath: '/app/inbox'
      preLoaderRoute: typeof AppInboxRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/generate': {
      id: '/app/generate'
      path: '/generate'
      fullPath: '/app/generate'
      preLoaderRoute: typeof AppGenerateRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/careers': {
      id: '/app/careers'
      path: '/careers'
      fullPath: '/app/careers'
      preLoaderRoute: typeof AppCareersRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/calendar': {
      id: '/app/calendar'
      path: '/calendar'
      fullPath: '/app/calendar'
      preLoaderRoute: typeof AppCalendarRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/bulk': {
      id: '/app/bulk'
      path: '/bulk'
      fullPath: '/app/bulk'
      preLoaderRoute: typeof AppBulkRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/billing': {
      id: '/app/billing'
      path: '/billing'
      fullPath: '/app/billing'
      preLoaderRoute: typeof AppBillingRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/audit': {
      id: '/app/audit'
      path: '/audit'
      fullPath: '/app/audit'
      preLoaderRoute: typeof AppAuditRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/analytics': {
      id: '/app/analytics'
      path: '/analytics'
      fullPath: '/app/analytics'
      preLoaderRoute: typeof AppAnalyticsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/brands/': {
      id: '/app/brands/'
      path: '/brands'
      fullPath: '/app/brands/'
      preLoaderRoute: typeof AppBrandsIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/brands/new': {
      id: '/app/brands/new'
      path: '/brands/new'
      fullPath: '/app/brands/new'
      preLoaderRoute: typeof AppBrandsNewRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/brands/$brandId': {
      id: '/app/brands/$brandId'
      path: '/brands/$brandId'
      fullPath: '/app/brands/$brandId'
      preLoaderRoute: typeof AppBrandsBrandIdRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/brands/$brandId/integrations': {
      id: '/app/brands/$brandId/integrations'
      path: '/integrations'
      fullPath: '/app/brands/$brandId/integrations'
      preLoaderRoute: typeof AppBrandsBrandIdIntegrationsRouteImport
      parentRoute: typeof AppBrandsBrandIdRoute
    }
  }
}

interface AppBrandsBrandIdRouteChildren {
  AppBrandsBrandIdIntegrationsRoute: typeof AppBrandsBrandIdIntegrationsRoute
}

const AppBrandsBrandIdRouteChildren: AppBrandsBrandIdRouteChildren = {
  AppBrandsBrandIdIntegrationsRoute: AppBrandsBrandIdIntegrationsRoute,
}

const AppBrandsBrandIdRouteWithChildren =
  AppBrandsBrandIdRoute._addFileChildren(AppBrandsBrandIdRouteChildren)

interface AppRouteRouteChildren {
  AppAnalyticsRoute: typeof AppAnalyticsRoute
  AppAuditRoute: typeof AppAuditRoute
  AppBillingRoute: typeof AppBillingRoute
  AppBulkRoute: typeof AppBulkRoute
  AppCalendarRoute: typeof AppCalendarRoute
  AppCareersRoute: typeof AppCareersRoute
  AppGenerateRoute: typeof AppGenerateRoute
  AppInboxRoute: typeof AppInboxRoute
  AppIntegrationsRoute: typeof AppIntegrationsRoute
  AppMoreRoute: typeof AppMoreRoute
  AppPostsRoute: typeof AppPostsRoute
  AppSettingsRoute: typeof AppSettingsRoute
  AppIndexRoute: typeof AppIndexRoute
  AppBrandsBrandIdRoute: typeof AppBrandsBrandIdRouteWithChildren
  AppBrandsNewRoute: typeof AppBrandsNewRoute
  AppBrandsIndexRoute: typeof AppBrandsIndexRoute
}

const AppRouteRouteChildren: AppRouteRouteChildren = {
  AppAnalyticsRoute: AppAnalyticsRoute,
  AppAuditRoute: AppAuditRoute,
  AppBillingRoute: AppBillingRoute,
  AppBulkRoute: AppBulkRoute,
  AppCalendarRoute: AppCalendarRoute,
  AppCareersRoute: AppCareersRoute,
  AppGenerateRoute: AppGenerateRoute,
  AppInboxRoute: AppInboxRoute,
  AppIntegrationsRoute: AppIntegrationsRoute,
  AppMoreRoute: AppMoreRoute,
  AppPostsRoute: AppPostsRoute,
  AppSettingsRoute: AppSettingsRoute,
  AppIndexRoute: AppIndexRoute,
  AppBrandsBrandIdRoute: AppBrandsBrandIdRouteWithChildren,
  AppBrandsNewRoute: AppBrandsNewRoute,
  AppBrandsIndexRoute: AppBrandsIndexRoute,
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(
  AppRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRouteRoute: AppRouteRouteWithChildren,
  ForgotPasswordRoute: ForgotPasswordRoute,
  OnboardingRoute: OnboardingRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SignInRoute: SignInRoute,
  SignUpRoute: SignUpRoute,
  VerifyEmailRoute: VerifyEmailRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
